/**
 * /frontend/src/features/analytics/components/shared/GranularitySelector.js
 */

import React, { useId } from 'react';
import './GranularitySelector.css';

const formatOptionLabel = (value) => {
  const normalized = String(value || '').trim().toUpperCase();
  switch (normalized) {
    case 'HOURLY':
      return 'Hour';
    case 'DAILY':
      return 'Day';
    case 'WEEKLY':
      return 'Week';
    case 'MONTHLY':
      return 'Month';
    default: {
      const words = String(value || '')
        .trim()
        .replace(/[_-]+/g, ' ')
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1));
      return words.join(' ') || '—';
    }
  }
};

/**
 * Granularity selector.
 * @param {{value:string,options:string[],onChange:Function,label?:string}} props
 * @returns {JSX.Element}
 */
const GranularitySelector = ({ value, options, onChange, label = 'Group by' }) => {
  const selectId = useId();

  return (
    <div className="analytics-granularity">
      <label className="analytics-granularity-label" htmlFor={selectId}>{label}</label>
      <select
        id={selectId}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-label={label}
      >
        {(options || []).map((option) => (
          <option key={option} value={option}>{formatOptionLabel(option)}</option>
        ))}
      </select>
    </div>
  );
};

export default GranularitySelector;
